// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ListCompaniesQueryVariables = Types.Exact<{
  pageNumber: Types.InputMaybe<Types.Scalars['Int']['input']>;
  pageSize: Types.InputMaybe<Types.Scalars['Int']['input']>;
  enabled?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  filterOnlyAccessible?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  hasEmployees?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  hasParentCompany?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  hasChildCompanies?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  onlyIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
  excludeIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
  countryIds?: Types.InputMaybe<Array<Types.Scalars['CountryCode']['input']> | Types.Scalars['CountryCode']['input']>;
}>;

export type ListCompaniesQuery = { __typename?: 'Query' } & {
  listCompanies: { __typename?: 'ListCompanies' } & Pick<Types.ListCompanies, 'totalCount'> & {
      items: Array<
        { __typename?: 'Company' } & Pick<
          Types.Company,
          | 'id'
          | 'name'
          | 'countryId'
          | 'probationReviewTimes'
          | 'googleOrgUnitPath'
          | 'hrEmailAddress'
          | 'jobTitleCanBeEmpty'
          | 'createPerformanceReviewAutomatically'
          | 'enabled'
          | 'createdAt'
          | 'updatedAt'
          | 'activeEmployeeCount'
          | 'acquiredDate'
          | 'preferredLanguage'
        > & {
            country: { __typename?: 'Country' } & Pick<Types.Country, 'id' | 'name'>;
            parentCompany: Types.Maybe<{ __typename?: 'Company' } & Pick<Types.Company, 'id' | 'name'>>;
            childrenCompanies: Array<{ __typename?: 'Company' } & Pick<Types.Company, 'id' | 'name'>>;
            probationReviewTerm: { __typename?: 'CompanyProbationReviewTerm' } & Pick<
              Types.CompanyProbationReviewTerm,
              'length' | 'mode'
            >;
            slackTeam: Types.Maybe<
              { __typename?: 'EmployeeExternalAccountSlackWorkspace' } & Pick<
                Types.EmployeeExternalAccountSlackWorkspace,
                'teamId' | 'teamName'
              >
            >;
          }
      >;
    };
};

export const ListCompaniesDocument = /*#__PURE__*/ gql`
    query listCompanies($pageNumber: Int, $pageSize: Int, $enabled: Boolean = null, $filterOnlyAccessible: Boolean = null, $hasEmployees: Boolean = null, $hasParentCompany: Boolean = null, $hasChildCompanies: Boolean = null, $onlyIds: [ID!] = null, $excludeIds: [ID!] = null, $countryIds: [CountryCode!] = null) {
  listCompanies(
    filter: {pageNumber: $pageNumber, pageSize: $pageSize, enabled: $enabled, filterOnlyAccessible: $filterOnlyAccessible, hasEmployees: $hasEmployees, hasParentCompany: $hasParentCompany, hasChildCompanies: $hasChildCompanies, onlyIds: $onlyIds, excludeIds: $excludeIds, countryIds: $countryIds}
  ) {
    items {
      id
      name
      country {
        id
        name
      }
      countryId
      parentCompany {
        id
        name
      }
      childrenCompanies {
        id
        name
      }
      probationReviewTerm {
        length
        mode
      }
      probationReviewTimes
      googleOrgUnitPath
      hrEmailAddress
      jobTitleCanBeEmpty
      createPerformanceReviewAutomatically
      enabled
      createdAt
      updatedAt
      activeEmployeeCount
      acquiredDate
      preferredLanguage
      slackTeam {
        teamId
        teamName
      }
    }
    totalCount
  }
}
    `;

/**
 * __useListCompaniesQuery__
 *
 * To run a query within a React component, call `useListCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCompaniesQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *      enabled: // value for 'enabled'
 *      filterOnlyAccessible: // value for 'filterOnlyAccessible'
 *      hasEmployees: // value for 'hasEmployees'
 *      hasParentCompany: // value for 'hasParentCompany'
 *      hasChildCompanies: // value for 'hasChildCompanies'
 *      onlyIds: // value for 'onlyIds'
 *      excludeIds: // value for 'excludeIds'
 *      countryIds: // value for 'countryIds'
 *   },
 * });
 */
export function useListCompaniesQuery(
  baseOptions?: Apollo.QueryHookOptions<ListCompaniesQuery, ListCompaniesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListCompaniesQuery, ListCompaniesQueryVariables>(ListCompaniesDocument, options);
}
export function useListCompaniesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListCompaniesQuery, ListCompaniesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListCompaniesQuery, ListCompaniesQueryVariables>(ListCompaniesDocument, options);
}
// @ts-expect-error
export function useListCompaniesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListCompaniesQuery, ListCompaniesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListCompaniesQuery, ListCompaniesQueryVariables>;
export function useListCompaniesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCompaniesQuery, ListCompaniesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListCompaniesQuery | undefined, ListCompaniesQueryVariables>;
export function useListCompaniesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCompaniesQuery, ListCompaniesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListCompaniesQuery, ListCompaniesQueryVariables>(ListCompaniesDocument, options);
}
export type ListCompaniesQueryHookResult = ReturnType<typeof useListCompaniesQuery>;
export type ListCompaniesLazyQueryHookResult = ReturnType<typeof useListCompaniesLazyQuery>;
export type ListCompaniesSuspenseQueryHookResult = ReturnType<typeof useListCompaniesSuspenseQuery>;
